import { Box, Button, Card, Flex, Text } from '@chakra-ui/react';
import { isBrowser, useCookieConsentStore } from '@onbeam/utils';
import useTranslation from 'next-translate/useTranslation';
import { createPortal } from 'react-dom';

export const CookieConsentPopup = () => {
  const { t } = useTranslation('common');
  const { isConsentPopupOpen, openConsentModal, updateConsent } = useCookieConsentStore();

  const handleSetAll = (value: boolean) =>
    updateConsent({
      ad_personalization: value,
      ad_storage: value,
      ad_user_data: value,
      analytics_storage: value,
      functionality_storage: true,
    });

  if (!isBrowser || !isConsentPopupOpen) return null;

  return createPortal(
    <Box
      position="fixed"
      zIndex="cookie-notice"
      bottom={0}
      left={0}
      px={{ base: '3', sm: '6' }}
      pb={{ base: '3', sm: '6' }}
      transform="translateY(100%)"
      animation="slideUp 0.5s 2s forwards"
      data-testid="cookie-consent-popup"
      sx={{
        '@keyframes slideUp': {
          from: {
            transform: 'translateY(100%)',
          },
          to: {
            transform: 'translateY(0)',
          },
        },
      }}
    >
      <Card
        p={4}
        bg="blackBg"
        w="full"
        maxW="sm"
        shadow="md"
        border="1px solid"
        borderColor="border"
      >
        <Text color="white">{t('cookie-modal.title')}</Text>
        <Text mt={1.5} mb={3} color="gray.6" fontSize="xs">
          {t('cookie-modal.description')}
        </Text>
        <Flex gap={1.5}>
          <Button lineHeight={1} variant="primary" size="sm" onClick={() => handleSetAll(true)}>
            {t('cookie-modal.accept-label')}
          </Button>
          <Button lineHeight={1} variant="secondary" size="sm" onClick={openConsentModal}>
            {t('cookie-modal.manage-label')}
          </Button>
          <Button lineHeight={1} variant="secondary" size="sm" onClick={() => handleSetAll(false)}>
            {t('cookie-modal.reject-label')}
          </Button>
        </Flex>
      </Card>
    </Box>,
    document.body,
  );
};
